import styled from "styled-components";
import { Box, Tab } from "@material-ui/core";

export const ValidationTab = styled(Tab)`
    .MuiTab-wrapper {
        flex-direction: row-reverse;
        justify-content: space-around;
    }
`;

export const AddOptionalIconButton = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    & svg {
        width: 100%;
        height: 90px;
        cursor: pointer;
        color: ${({ theme }) => theme.palette.grey["300"]};

        &:hover {
            color: rgb(0, 0, 0, 0.24);
        }
    }
`;
